export const news = {
    'news.title': '{title} - 新闻 | R.Toys',
    'news.default': '新闻',
}
